<script lang="ts">
  import type { ClassificationParam } from '../types';
  import ClassificationList from './classification-list.svelte';

  export let creationYear: string | number | null = null;
  export let locations: string | null = null;
  export let styles: ClassificationParam[] | null = null;
  export let medium: ClassificationParam[] | null = null;
  export let canvasSize: string | null;
  export let framing: string;

  $: classificationList = [
    {
      name: 'Styles',
      value: styles,
    },
    {
      name: 'Medium',
      value: medium,
    },
  ];
</script>

<article>
  <strong class="mb-4 block text-base">Physical original details</strong>

  <ul class="flex w-full flex-col gap-2 text-base">
    {#if locations}
      <li class="flex items-center justify-between">
        <span class="flex-0.4 text-default-600 dark:text-default-500"> Country </span>

        <div class="flex-0.7">
          <span class="font-medium">{locations}</span>
        </div>
      </li>
    {/if}

    <li class="flex items-center justify-between">
      <span class="flex-0.4 text-default-600 dark:text-default-500"> Years </span>

      <div class="flex-0.7">
        <span class="font-medium">{creationYear}</span>
      </div>
    </li>

    <li>
      <ClassificationList items="{classificationList}" />
    </li>

    <li class="flex items-center justify-between">
      <span class="flex-0.4 text-default-600 dark:text-default-500"> Physical canvas </span>

      <div class="flex-0.7">
        <span class="font-medium">{canvasSize}</span>
      </div>
    </li>

    <li class="flex items-center justify-between">
      <span class="flex-0.4 text-default-600 dark:text-default-500"> Framing </span>

      <div class="flex-0.7">
        <span class="font-medium">{framing}</span>
      </div>
    </li>
  </ul>
</article>
